import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { TrailheadInView } from '../types/Trailhead';

export type TrailheadUiState = {
  hoveredTrailheadId: TrailheadInView['id'] | undefined;
  trailheadsInView: TrailheadInView[];
};

export const initialState: TrailheadUiState = {
  hoveredTrailheadId: undefined,
  trailheadsInView: []
};

const trailheadSlice = createSlice({
  name: 'trailhead',
  initialState,
  reducers: {
    setHoveredTrailheadId: (state, action: PayloadAction<TrailheadInView['id'] | undefined>) => {
      state.hoveredTrailheadId = action.payload;
    },
    setTrailheadsInView: (state, action: PayloadAction<TrailheadInView[]>) => {
      state.trailheadsInView = action.payload;
    }
  }
});

export const { setHoveredTrailheadId, setTrailheadsInView } = trailheadSlice.actions;
export default trailheadSlice.reducer;
